<template>
   <div>
     <!-- 主体内容 -->
    <el-row>
      <!-- title -->
      <div class="modt-box">权限管理</div>
      <el-col :span="4"> </el-col>
      
      <el-col :span="18">
        <!-- <div class="mod-btnbox">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addModule">添加</el-button>
        </div> -->
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
   
          <el-form-item label="权限名称" prop="title">
            <el-input size="small" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="权限" prop="rules">
             <el-checkbox-group v-model="form.rules" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="(items,index) in Permission" :label="items.value" :key="index">{{items.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="生效" prop="status">
         <el-switch
              v-model="value"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0">
                </el-switch>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  v-show="addshow" @click="saveModule('form')">保存</el-button>
            <el-button size="small" type="primary" v-show="showdelete" @click="editData">更新</el-button>
            <el-button size="small" type="primary" v-show="showdelete" @click="deleteModule">删除</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    </div>   


</template>

<script>

import { create_role} from '@/api/userFun'
export default {
 
    data(){
        return{
            Permission:[
              {label:'修改订单状态',value:'Modify_order_status'},
              {label:'增加订单',value:'Add_order'},
              {label:'删除订单',value:'Delete_Order'},
              {label:'修改业务员',value:'Modify_salesperson'},
              {label:'增加业务员',value:'Add_salesperson'},
              {label:'增加管理员',value:'Add_administrator'},
              ],
            addshow:true,
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            treeData: [],
            showdelete:false,
            checkedId:'',
            form: {
             status:1,
             title:'',
             rules:[],
             },
             fmenu:[],
             
              // rules表单验证
            rules: {
                rules: [
                { required: true, message: '请选择权限', trigger: 'blur' }
                ],
                title: [
                { required: true, message: '请输入权限名称', trigger: 'blur' }
                ],
            },
        }
    },
    created(){
        parent_menu().then(res=>{
            this.fmenu=res.data
        })
       this.getdata();
    },
   methods: {

   handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
       // this.checkAll = checkedCount === this.cities.length;
       // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      },
    getdata(){
        menu_list().then(res=>{
                this.treeData=res.data;
        })
    },
    // 复选变单选
    handleClick(data, checked, node) {
      if (checked) {
        this.addshow=false;
        this.checkedId=data.value;
        //this.$refs.tree.setCheckedNodes([])
        menuById(this.checkedId).then(res=>{
            this.form=res.data;
        });
        this.showdelete = true

      } else {
        this. clearForm('form');
        console.log(this.form);
        this.addshow=true;
        this.showdelete = false
      }
    },

     clearForm(form){
        this.$refs[form].resetFields();
        if(this.form.hasOwnProperty('id')){
            delete this.form.id;
        }

     },  
    
    // 保存菜单
    saveModule(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          create_role(this.form)
            .then(res => {
              this.getdata()
            //   this.getmenu()
            })
        } else {
          return false
        }
      })
    },
    // 删除菜单
    deleteModule() {
      menu_del(this.checkedId)
        .then(res => {
          this.getdata()
          //this.getmenu()
          this.$message.error('菜单管理列表删除成功！')
        })
    }
  
   },

}
</script>
<style>
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/system/menu.vue